import { Tooltip, TooltipContent, TooltipTrigger } from "design-system/atoms/Tooltip"
import { useCampaignTimeFrame } from "modules/campaigns/components/Detail/CampaignTimeFrameContext"
import { useNPSQuery } from "modules/insights/hooks/useNPSQuery"
import { useTranslation } from "react-i18next"
import { GoalResponseDataSchema } from "schema"
import z from "zod"
import { NetPromoterDistribution } from "./NetPromoterDistribution"
import { NetPromoterEvolution } from "./NetPromoterEvolution"
import { NetPromoterScore } from "./NetPromoterScore"

type Props = {
  campaignId?: string
  goal: z.infer<typeof GoalResponseDataSchema>
}

export const NPSInsights = ({ campaignId, goal }: Props) => {
  const { t } = useTranslation()
  const { timeFrame } = useCampaignTimeFrame()

  const { data, isPending } = useNPSQuery({ timeFrame, campaignId, goalId: goal.id })

  const title = goal.displayName ?? t("insights.nps.title")
  const description = goal.assistantInstructions

  const header = description ? (
    <Tooltip>
      <TooltipTrigger slick>
        <span className="text-md font-medium">{title}</span>
      </TooltipTrigger>
      <TooltipContent>{description}</TooltipContent>
    </Tooltip>
  ) : (
    <span className="text-md font-medium">{title}</span>
  )

  return (
    <div className="flex flex-col gap-3 w-full">
      {header}
      <div className="flex flex-col xl:flex-row w-full gap-4 overflow-x-auto">
        <NetPromoterScore data={data} isPending={isPending} />
        <NetPromoterDistribution data={data} isPending={isPending} timeFrame={timeFrame} />
        <NetPromoterEvolution data={data} isPending={isPending} />
      </div>
    </div>
  )
}
